import { useFormik } from 'formik'
import { FC } from 'react'
import { ButtonType, showAlert, showError } from '../../../../../../../_metronic/helpers'
import { useSearchParams } from 'react-router-dom'
import { createCargoCliente, editCargoCliente } from '../../core/_request'
import { CargoAsoDtoCreate, CargoAsoDtoUpdate, CargoAsoView } from '../../core/_models'
import {
  Button,
  FetchState,
  FormInput,
  ListLoading,
  LoadingIndicator,
  useModal,
} from '../../../../../../components'
import { cargoSchema } from './validation/cargoSchema'
import { useT } from '_metronic/i18n/Metronici18n'

export const CargoClienteModal: FC = () => {
  const { fetchStates, closeModal } = useModal()
  const { t } = useT()

  const { data: cargo } = (fetchStates['cargo'] || {}) as FetchState<CargoAsoView>

  const [searchParams] = useSearchParams()
  const idCliente = Number(searchParams.get('cliente'))

  const initialValues = {
    nome: cargo?.nome || '',
    codigo: cargo?.codigo || '',
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: cargoSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        if (cargo) {
          const updatedCargo: CargoAsoDtoUpdate = {
            codigo: values.codigo,
            nome: values.nome,
            ativo: cargo.ativo,
          }
          await editCargoCliente(cargo.id, updatedCargo)
          showAlert({ title: 'Sucesso!', text: 'Cargo alterado com sucesso!', icon: 'success' })
        } else {
          const cargo: CargoAsoDtoCreate = {
            nome: values.nome,
            codigo: values.codigo,
          }
          await createCargoCliente(idCliente, cargo)
          showAlert({ title: 'Sucesso!', text: 'Cargo criado com sucesso!', icon: 'success' })
        }
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form onSubmit={formik.handleSubmit} noValidate>
      <div className='row'>
        <div className='col-md-7'>
          <FormInput
            formik={formik}
            name='nome'
            placeholder='Digite o nome do cargo'
            label='Nome'
          />
        </div>
        <div className='col-md-5'>
          <FormInput
            formik={formik}
            name='codigo'
            placeholder='Digite o código do cargo'
            label='Código'
          />
        </div>
      </div>
      <div className='d-flex justify-content-center mt-10'>
        <Button type={ButtonType.Reset} onClick={closeModal} className='btn-secondary me-3'>
          {t('common.cancel')}
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary'>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.send')}
        </Button>
      </div>
      {formik.isSubmitting && <ListLoading />}
    </form>
  )
}
